const groupedAccountTypes = [
  {
    label: "Asset",
    options: [
      { acc_type_name: "Cash-in-Hand", acc_type_id: "cash_in_hand", label: "Cash-in-Hand", value: "cash_in_hand" },
      { acc_type_name: "Bank Accounts", acc_type_id: "bank_account", label: "Bank Account", value: "bank_account" },
      { acc_type_name: "Fixed Assets", acc_type_id: "fixed_asset", label: "Fixed Asset", value: "fixed_asset" },
      { acc_type_name: "Investment", acc_type_id: "investment", label: "Investment", value: "investment" },
      { acc_type_name: "Current Assets", acc_type_id: "current_assets", label: "Current Assets", value: "current_assets" },
      { acc_type_name: "Deposit Accounts", acc_type_id: "deposit_accounts", label: "Deposit Accounts", value: "deposit_accounts" },
      { acc_type_name: "Suspense Accounts", acc_type_id: "suspense_accounts", label: "Suspense Accounts", value: "suspense_accounts" },
      { acc_type_name: "Intangible Assets", acc_type_id: "intangible_asset", label: "Intangible Asset", value: "intangible_asset" },
    ],
  },
  {
    label: "Liability",
    options: [
      { acc_type_name: "Loans (Liability)", acc_type_id: "loan", label: "Loan", value: "loan" },
      { acc_type_name: "Current Liability", acc_type_id: "current_liability", label: "Current Liability", value: "current_liability" },
      { acc_type_name: "Duties & Taxes", acc_type_id: "dutie_&_tax", label: "Duties & Tax", value: "dutie_&_tax" },
    ],
  },
  {
    label: "Equity",
    options: [
      { acc_type_name: "Capital Account", acc_type_id: "capital", label: "Capital Account", value: "capital" },
      { acc_type_name: "Reserve & Surplus", acc_type_id: "reserve_surplus", label: "Reserve & Surplus", value: "reserve_surplus" },
      { acc_type_name: "Retained Earnings", acc_type_id: "retained_earnings", label: "Retained Earnings", value: "retained_earnings" },
    ],
  },
{
  label: "Expense",
  options: [
    { acc_type_name: "Direct Expense", acc_type_id: "direct_expense", label: "Direct Expense", value: "direct_expense" },
    { acc_type_name: "Indirect Expenses", acc_type_id: "indirect_expense", label: "Indirect Expense", value: "indirect_expense" },
    { acc_type_name: "Purchase Account", acc_type_id: "purchase_account", label: "Purchase Account", value: "purchase_account" }, // ✅ ADD
    { acc_type_name: "Purchase Return", acc_type_id: "purchase_return", label: "Purchase Return", value: "purchase_return" },     // ✅ ADD
    { acc_type_name: "Service Expense", acc_type_id: "service_expense_account", label: "Service Expense", value: "service_expense_account" },    // ✅ ADD
  ],
},
{
  label: "Income",
  options: [
    { acc_type_name: "Direct Incomes", acc_type_id: "direct_income", label: "Direct Income", value: "direct_income" },
    { acc_type_name: "Indirect Incomes", acc_type_id: "indirect_income", label: "Indirect Income", value: "indirect_income" },
    { acc_type_name: "Sales Account", acc_type_id: "sale_account", label: "Sales Account", value: "sale_account" },
    { acc_type_name: "Sales Return", acc_type_id: "sale_return", label: "Sales Return", value: "sale_return" },
    { acc_type_name: "Service Account", acc_type_id: "service_account", label: "Service Account", value: "service_account" }, // ✅ ADD
    { acc_type_name: "Service Return", acc_type_id: "service_return", label: "Service Return", value: "service_return" },
  ],
},
];

// Keep getAccountType for backward compatibility — flattens the groups
const getAccountType = () => {
  return groupedAccountTypes.flatMap((group) => group.options);
};

const getGroupedAccountTypes = () => {
  return groupedAccountTypes;
};

export { getAccountType, getGroupedAccountTypes };